import * as React from 'react';

const twitterIcon = (<svg width="29" height="29" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.1228 2.59766H23.827L15.7345 11.8468L25.2546 24.4329H17.8004L11.962 16.7995L5.28155 24.4329H1.57516L10.2309 14.5399L1.09814 2.59766H8.7416L14.019 9.57486L20.1228 2.59766ZM18.8228 22.2158H20.8753L7.62632 4.69832H5.42376L18.8228 22.2158Z" fill="#024EC1"/>
    </svg>
    );

export default twitterIcon;